import React, { useState, useEffect, useContext } from 'react';
import SwipeableViews from 'react-swipeable-views';
import axios from 'axios';
import AppContext from '../../Context/AppContext';
import StepHeader from '../Step1/StepHeader';
import Header from './Header/Header';
import SelectGoalSection from './SelectGoals/SelectGoalSection';
import configData from '../../config.json';
import OolaSevenSection from './SelectGoals/OolaSevenSection';
import OolaOneSection from './SelectGoals/OolaOneSection';
import OolaFinishSection from './SelectGoals/OolaFinishSection';
import OolaOneSectionSelect from './SelectGoals/OolaOneSectionSelect';
import './SelectGoalsStep2.css';
import SelectFinishSection from './SelectGoals/SelectFinishSection';

const readApiGoalId = (item) =>
    item?.goalId ?? item?.GoalId ?? null;

const readSavedGoalId = (item) => item?.id ?? item?.Id ?? null;

const getAreaGoals = (selectedGoals, areaId) =>
    selectedGoals
        .filter((x) => x.areaId === areaId)
        .sort(
            (a, b) =>
                (a.recomendationIndex ?? 0) - (b.recomendationIndex ?? 0)
        );

const areaGoalsReadyToSave = (goals) =>
    goals.length >= 3 &&
    goals.every(
        (g) => String(g.text || '').trim() !== '' && g.date != null
    );

const areaGoalsPersisted = (goals) =>
    goals.length >= 3 &&
    goals.every((g) => g.GoalId != null && g.GoalId > 0);

const SelectGoalsStep2 = (props) => {
    const { checkUserSession, updateUserStepId, changeLoading } =
        useContext(AppContext);
    const currUser = checkUserSession();
    const [show, setShow] = useState(false);
    const [saveAreaLoading, setSaveAreaLoading] = useState(false);
    const [saveAreaFeedback, setSaveAreaFeedback] = useState('');
    const [step2Ready, setStep2Ready] = useState(false);

    const [data, changeData] = useState({
        CurrentF: 0,
        CurrentStep2: 0,
        LastReachedF: 0,
        latestAssessmentScore: 0,
        Fs: [
            {
                areaId: 1,
                name: 'Fitness',
                score: 0,
                color: '#15C285',
                recommendedGoals: [],
            },
            {
                areaId: 2,
                name: 'Finance',
                score: 0,
                color: '#ABD86D',
                recommendedGoals: [],
            },
            {
                areaId: 3,
                name: 'Family',
                score: 0,
                color: '#FBBF53',
                recommendedGoals: [],
            },
            {
                areaId: 4,
                name: 'Faith',
                score: 0,
                color: '#F26636',
                recommendedGoals: [],
            },
            {
                areaId: 5,
                name: 'Field',
                score: 0,
                color: '#EC0F47',
                recommendedGoals: [],
            },
            {
                areaId: 6,
                name: 'Friends',
                score: 0,
                color: '#700460',
                recommendedGoals: [],
            },
            {
                areaId: 7,
                name: 'Fun',
                score: 0,
                color: '#022B7A',
                recommendedGoals: [],
            },
        ],
        SelectedGoals: [],
        SelectedGoalsSeven: [],
        SelectedOolaOne: {},
    });

    const dataLoad = () =>
        data.Fs.map((item) => ({
            id: item.areaId,
            name: item.name,
            tabColor: item.color,
        }));

    function updateIndexStep2(i) {
        // Functional update — avoid stale state wiping SelectedGoalsSeven, etc.
        changeData((prev) => ({
            ...prev,
            CurrentStep2: (Number(prev.CurrentStep2) || 0) + i,
            changeData,
        }));
        window.scrollTo(0, 0);
    }

    function getURL() {
        return configData.SERVER_URL;
    }

    useEffect(() => {
        changeLoading(true);
        const applyStep2Preview = (newAllProps, Fs) => {
            try {
                const preview = new URLSearchParams(
                    window.location.search
                ).get('preview');
                if (
                    preview === 'step2' ||
                    preview === 'step2-goals' ||
                    preview === 'goals'
                ) {
                    newAllProps.CurrentStep2 = 1;
                    newAllProps.CurrentF = Math.min(
                        Number(newAllProps.CurrentF) || 0,
                        6
                    );
                    newAllProps.LastReachedF = Math.max(
                        Number(newAllProps.LastReachedF) || 0,
                        newAllProps.CurrentF
                    );
                }
                if (
                    preview === 'step2-pick7' ||
                    preview === 'pick7' ||
                    preview === 'top7'
                ) {
                    const pick7PreviewScores = [
                        6.2, 5.1, 7.1, 5.8, 5.5, 4.4, 5.3,
                    ];
                    const pick7DefaultAreas = [
                        { areaId: 1, name: 'Fitness', color: '#15C285' },
                        { areaId: 2, name: 'Finance', color: '#ABD86D' },
                        { areaId: 3, name: 'Family', color: '#FBBF53' },
                        { areaId: 4, name: 'Faith', color: '#F26636' },
                        { areaId: 5, name: 'Field', color: '#EC0F47' },
                        { areaId: 6, name: 'Friends', color: '#700460' },
                        { areaId: 7, name: 'Fun', color: '#022B7A' },
                    ];
                    const pick7GoalTexts = [
                        [
                            'Exercise 4 days per week',
                            'Improve sleep to 7+ hours nightly',
                            'Meal prep healthy lunches on Sundays',
                        ],
                        [
                            'Build a 3-month emergency fund',
                            'Track every expense for 30 days',
                            'Automate 10% to savings each paycheck',
                        ],
                        [
                            'Weekly family dinner — no phones',
                            'Plan a monthly family outing',
                            'Write a letter to each child monthly',
                        ],
                        [
                            'Morning reflection 10 minutes daily',
                            'Attend weekly service or study group',
                            'Volunteer monthly in the community',
                        ],
                        [
                            'Complete professional certification',
                            'Network with 2 mentors quarterly',
                            'Update resume and LinkedIn profile',
                        ],
                        [
                            'Reconnect with two close friends',
                            'Host a dinner party for friends',
                            'Schedule monthly coffee dates',
                        ],
                        [
                            'Plan one fun adventure per month',
                            'Try a new hobby this quarter',
                            'Take a weekend trip without work',
                        ],
                    ];
                    const normalizePick7Score = (value, fallback) => {
                        const n = Number(value);
                        if (!Number.isFinite(n) || n <= 0) {
                            return fallback;
                        }
                        return n > 10 ? n / 10 : n;
                    };
                    const pick7FsSource =
                        (Fs && Fs.length > 0
                            ? Fs
                            : newAllProps.Fs && newAllProps.Fs.length > 0
                              ? newAllProps.Fs
                              : pick7DefaultAreas) || pick7DefaultAreas;
                    const pick7Fs = pick7FsSource.map((f, i) => ({
                        areaId:
                            f.areaId ?? pick7DefaultAreas[i]?.areaId ?? i + 1,
                        name: f.name ?? pick7DefaultAreas[i]?.name ?? 'Fitness',
                        color:
                            f.color ?? pick7DefaultAreas[i]?.color ?? '#15C285',
                        score: normalizePick7Score(
                            f.score,
                            pick7PreviewScores[i] ?? 5.5
                        ),
                        recommendedGoals: [],
                    }));

                    const pick7SelectedGoals = [];
                    const pick7SelectedSeven = [];
                    const pick7SelectedGoalsGroup = {};

                    pick7Fs.forEach((f, areaId) => {
                        const completeDate = new Date();
                        completeDate.setDate(
                            completeDate.getDate() + 30 + areaId * 7
                        );
                        const texts =
                            pick7GoalTexts[areaId] ||
                            [
                                `${f.name} goal 1`,
                                `${f.name} goal 2`,
                                `${f.name} goal 3`,
                            ];
                        const selected = texts.map((text, goalIndex) => {
                            const isSelected = goalIndex === 0;
                            const idL = `${areaId}${goalIndex}`;
                            const goal = {
                                areaId,
                                recomendationIndex: goalIndex,
                                text,
                                date: new Date(completeDate.getTime()),
                                Id: areaId * 10 + goalIndex,
                                selected: isSelected,
                                ...(isSelected ? { id: idL, idL } : {}),
                            };
                            pick7SelectedGoals.push(goal);
                            if (isSelected) {
                                pick7SelectedSeven.push(goal);
                            }
                            return goal;
                        });
                        pick7SelectedGoalsGroup[areaId] = {
                            Fs: f,
                            selected,
                        };
                    });

                    newAllProps.Fs = pick7Fs;
                    newAllProps.latestAssessmentScore = 5.5;
                    newAllProps.CurrentStep2 = 3;
                    newAllProps.CurrentF = 0;
                    newAllProps.LastReachedF = 6;
                    newAllProps.SelectedGoals = pick7SelectedGoals;
                    newAllProps.SelectedGoalsSeven = pick7SelectedSeven;
                    newAllProps.SelectedGoalsGroup = pick7SelectedGoalsGroup;
                }
                if (
                    preview === 'step2-arrange' ||
                    preview === 'arrange' ||
                    preview === 'arrange7' ||
                    preview === 'step2-oolaone' ||
                    preview === 'oolaone' ||
                    preview === 'oola1' ||
                    preview === 'step2-finish' ||
                    preview === 'step2-complete' ||
                    preview === 'finish'
                ) {
                    const isOolaOnePreview =
                        preview === 'step2-oolaone' ||
                        preview === 'oolaone' ||
                        preview === 'oola1';
                    const isFinishPreview =
                        preview === 'step2-finish' ||
                        preview === 'step2-complete' ||
                        preview === 'finish';
                    newAllProps.CurrentStep2 = isFinishPreview
                        ? 7
                        : isOolaOnePreview
                          ? 6
                          : 4;
                    newAllProps.CurrentF = 0;
                    newAllProps.LastReachedF = 6;

                    let top7 = (newAllProps.SelectedGoalsSeven || []).filter(
                        Boolean
                    );

                    if (top7.length < 7) {
                        try {
                            const raw =
                                sessionStorage.getItem('pv2-top7-picks');
                            const stored = raw ? JSON.parse(raw) : null;
                            if (Array.isArray(stored) && stored.length > 0) {
                                top7 = stored.filter(Boolean);
                            }
                        } catch {
                            /* ignore */
                        }
                    }

                    if (top7.length > 0) {
                        newAllProps.SelectedGoalsSeven = top7.slice(0, 7);
                    } else {
                        const areas =
                            (Fs || []).length > 0
                                ? Fs
                                : [
                                      { name: 'Fitness', color: '#15c285' },
                                      { name: 'Finance', color: '#efd078' },
                                      { name: 'Family', color: '#5b8def' },
                                      { name: 'Friends', color: '#e07a5f' },
                                      { name: 'Field', color: '#81b29a' },
                                      { name: 'Faith', color: '#9b5de5' },
                                      { name: 'Fun', color: '#f28482' },
                                  ];
                        if (!(Fs || []).length) {
                            newAllProps.Fs = areas;
                        }
                        newAllProps.SelectedGoalsSeven = areas.map(
                            (f, areaId) => {
                                const d = new Date();
                                d.setDate(d.getDate() + 40 + areaId);
                                return {
                                    areaId,
                                    recomendationIndex: 0,
                                    text: `${f.name}: lead with purpose this season`,
                                    date: d,
                                    Id: areaId,
                                    GoalId: null,
                                    selected: true,
                                    selectedOne: false,
                                    idL: `${areaId}0`,
                                };
                            }
                        );
                    }

                    if (isOolaOnePreview) {
                        newAllProps.SelectedGoalsSeven = (
                            newAllProps.SelectedGoalsSeven || []
                        ).map((g) => ({
                            ...g,
                            selectedOne: false,
                        }));
                        newAllProps.SelectedOolaOne = {};
                    }

                    if (isFinishPreview) {
                        const seven = newAllProps.SelectedGoalsSeven || [];
                        const pick =
                            seven.find((g) => g?.selectedOne) ||
                            (newAllProps.SelectedOolaOne?.text
                                ? newAllProps.SelectedOolaOne
                                : null) ||
                            seven.find((g) => Number(g.areaId) === 2) ||
                            seven[0] || {
                                areaId: 2,
                                text: 'Schedule an appointment with a family counselor',
                            };
                        newAllProps.SelectedOolaOne = {
                            ...pick,
                            selectedOne: true,
                        };
                        newAllProps.SelectedGoalsSeven = seven.map((g, i) => ({
                            ...g,
                            selectedOne:
                                (pick.GoalId != null &&
                                    g.GoalId === pick.GoalId) ||
                                (pick.idL && g.idL === pick.idL) ||
                                (g.areaId === pick.areaId &&
                                    g.text === pick.text) ||
                                i === seven.indexOf(pick),
                        }));
                    }
                }
            } catch {
                /* ignore */
            }
            return newAllProps;
        };

        const url = `${getURL()}goals/${currUser.userId}`;
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${currUser.token}` },
            })
            .then((result) => {
                const AllProps = { ...data };
                const Fs = [];
                (result.data || []).forEach((item) => {
                    Fs.push(item);
                });
                AllProps.Fs = Fs;
                AllProps.changeData = changeData;
                changeData(AllProps);

                const urlGoals = `${getURL()}goals/GetUserGoals`;
                axios
                    .get(urlGoals, {
                        headers: { Authorization: `Bearer ${currUser.token}` },
                    })
                    .then((result2) => {
                        const newAllProps = {
                            ...data,
                            SelectedGoals: [],
                            SelectedGoalsSeven: [],
                        };
                        let index = 0;
                        (result2.data?.userGoals || []).forEach((item) => {
                            if (index === 3) index = 0;
                            let dateValue = null;
                            if (
                                item.completedByDate &&
                                item.completedByDate !== ''
                            ) {
                                const parsedDate = new Date(
                                    item.completedByDate
                                );
                                dateValue = !isNaN(parsedDate.getTime())
                                    ? parsedDate
                                    : null;
                            }
                            newAllProps.SelectedGoals.push({
                                recomendationIndex: index,
                                text: item.text,
                                areaId: item.areaId - 1,
                                date: dateValue,
                                GoalId: readApiGoalId(item),
                            });
                            index += 1;
                        });
                        newAllProps.Fs = Fs;
                        newAllProps.latestAssessmentScore =
                            result2.data?.latestAssessmentScore;
                        newAllProps.changeData = changeData;
                        newAllProps.CurrentF = Math.floor(
                            newAllProps.SelectedGoals.length / 3
                        );
                        newAllProps.LastReachedF = newAllProps.CurrentF;

                        if (newAllProps.CurrentF > 0) {
                            if (newAllProps.SelectedGoals.length === 21) {
                                const unordered = (
                                    result2.data.userGoals || []
                                ).filter((x) => x.sevenGoalOrder === 0);
                                const ordered = (
                                    result2.data.userGoals || []
                                ).filter((x) => x.sevenGoalOrder > 0);

                                if (unordered.length === 7) {
                                    unordered.forEach((item, i) => {
                                        const x =
                                            newAllProps.SelectedGoals.find(
                                                (xx) =>
                                                    xx.GoalId ===
                                                    readApiGoalId(item)
                                            );
                                        if (!x) return;
                                        newAllProps.SelectedGoalsSeven.push({
                                            areaId: x.areaId,
                                            date: x.date,
                                            recomendationIndex:
                                                x.recomendationIndex,
                                            text: x.text,
                                            selected: true,
                                            Id: i,
                                            GoalId: x.GoalId,
                                        });
                                    });
                                    newAllProps.CurrentStep2 = 4;
                                } else if (ordered.length === 7) {
                                    ordered
                                        .sort(
                                            (a, b) =>
                                                a.sevenGoalOrder -
                                                b.sevenGoalOrder
                                        )
                                        .forEach((item, i) => {
                                            const x =
                                                newAllProps.SelectedGoals.find(
                                                    (xx) =>
                                                        xx.GoalId ===
                                                        readApiGoalId(item)
                                                );
                                            if (!x) return;
                                            newAllProps.SelectedGoalsSeven.push(
                                                {
                                                    areaId: x.areaId,
                                                    date: x.date,
                                                    recomendationIndex:
                                                        x.recomendationIndex,
                                                    text: x.text,
                                                    selected: true,
                                                    Id: i,
                                                    GoalId: x.GoalId,
                                                }
                                            );
                                        });
                                    newAllProps.CurrentStep2 = 5;
                                } else {
                                    newAllProps.CurrentStep2 = 2;
                                }

                                newAllProps.CurrentF = 0;
                            } else {
                                newAllProps.CurrentStep2 = 1;
                            }
                        }

                        changeData(applyStep2Preview(newAllProps, Fs));
                        setStep2Ready(true);
                        changeLoading(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        const fallback = {
                            ...data,
                            Fs,
                            changeData,
                            SelectedGoals: [],
                            SelectedGoalsSeven: [],
                        };
                        changeData(applyStep2Preview(fallback, Fs));
                        setStep2Ready(true);
                        changeLoading(false);
                    });
            })
            .catch((error) => {
                console.log(error);
                const fallback = {
                    ...data,
                    changeData,
                    SelectedGoals: [],
                    SelectedGoalsSeven: [],
                };
                changeData(applyStep2Preview(fallback, []));
                setStep2Ready(true);
                changeLoading(false);
            });
    }, []);

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    function changePage() {
        updateIndexStep2(1);
    }
    async function saveAreaGoalsIfNeeded(fromF, toF) {
        if (toF <= fromF) {
            return true;
        }
        const goals = getAreaGoals(data.SelectedGoals, fromF);
        if (!areaGoalsReadyToSave(goals)) {
            return true;
        }
        if (
            areaGoalsPersisted(goals) &&
            !goals.some((g) => g.dirty)
        ) {
            return true;
        }
        return saveRecomendedGoals({ areaId: fromF, silent: true });
    }

    async function saveCurrentAreaGoals() {
        const areaId = data.CurrentF;
        const goals = getAreaGoals(data.SelectedGoals, areaId);
        if (!areaGoalsReadyToSave(goals)) {
            return false;
        }
        if (
            areaGoalsPersisted(goals) &&
            !goals.some((g) => g.dirty)
        ) {
            setSaveAreaFeedback('saved');
            window.setTimeout(() => setSaveAreaFeedback(''), 1500);
            return true;
        }
        setSaveAreaLoading(true);
        setSaveAreaFeedback('');
        try {
            const ok = await saveRecomendedGoals({
                areaId,
                silent: true,
                skipIfClean: false,
            });
            if (ok) {
                setSaveAreaFeedback('saved');
                window.setTimeout(() => setSaveAreaFeedback(''), 1500);
            }
            return ok;
        } finally {
            setSaveAreaLoading(false);
        }
    }

    function saveRecomendedGoals(options = {}) {
        const opts =
            options && typeof options === 'object' ? options : {};
        const areaId =
            opts.areaId != null ? opts.areaId : data.CurrentF;
        const skipIfClean = opts.skipIfClean !== false;

        if (skipIfClean) {
            const goals = getAreaGoals(data.SelectedGoals, areaId);
            if (
                areaGoalsReadyToSave(goals) &&
                areaGoalsPersisted(goals) &&
                !goals.some((g) => g.dirty)
            ) {
                return Promise.resolve(true);
            }
        }

        const areaGoals = getAreaGoals(data.SelectedGoals, areaId);
        const PostObj = {
            userId: currUser.userId,
            Goals: areaGoals.map((item) => {
                const goal = {
                    AreaId: item.areaId + 1,
                    Text: item.text,
                    CompletedByDate: item.date,
                };
                // New goals have no id. Omit GoalId so the API treats them as
                // inserts. Sending null fails because GoalDetailDTO.GoalId is int.
                if (item.GoalId != null && Number(item.GoalId) > 0) {
                    goal.GoalId = item.GoalId;
                }
                return goal;
            }),
        };

        const url = `${configData.SERVER_URL}Goals/PartialSaveGoals`;
        return new Promise((resolve) => {
            axios
                .post(url, PostObj, {
                    headers: {
                        Authorization: `Bearer ${currUser.token}`,
                    },
                })
                .then((result) => {
                    // Merge GoalIds without resetting CurrentF / navigation
                    changeData((prev) => {
                        const SelectedGoals = prev.SelectedGoals.map(
                            (g) => ({ ...g })
                        );
                        const savedGoals = Array.isArray(result.data)
                            ? result.data
                            : [];
                        getAreaGoals(SelectedGoals, areaId).forEach(
                            (item, i) => {
                                if (
                                    item.GoalId == null &&
                                    savedGoals[i]
                                ) {
                                    item.GoalId =
                                        readSavedGoalId(savedGoals[i]);
                                }
                                item.dirty = false;
                            }
                        );
                        return {
                            ...prev,
                            SelectedGoals,
                            changeData,
                        };
                    });
                    resolve(true);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(false);
                });
        });
    }
    const saveButtonLabel = saveAreaLoading
        ? 'Saving…'
        : saveAreaFeedback === 'saved'
          ? 'Saved'
          : 'SAVE';

    if (!step2Ready) {
        return null;
    }

    const obj = (
        <>
            {data.CurrentStep2 === 1 &&
                data.LastReachedF > data.CurrentF &&
                props.mobile === false &&
                !props.portalV2 && (
                    <button
                        className="btnPartialSaveStep2"
                        type="button"
                        disabled={saveAreaLoading}
                        onClick={() => saveCurrentAreaGoals()}
                    >
                        {saveButtonLabel}
                    </button>
                )}
            <SwipeableViews
                className="step2__container"
                index={data.CurrentStep2}
                disabled
            >
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 0 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-intro"
                                url="https://player.vimeo.com/video/539418550"
                                title="STEP 2: WHERE YOU WANT TO GO"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section" style={{ height: 'auto' }}>
                    {data.CurrentStep2 === 1 ? (
                        <div
                            className={
                                props.portalV2
                                    ? 'pv2-step2-glass'
                                    : undefined
                            }
                        >
                            {!props.portalV2 ? (
                                <Header
                                    data={dataLoad()}
                                    AllState={data}
                                    changeData={changeData}
                                    mobile={props.mobile}
                                    saveAreaGoalsIfNeeded={
                                        saveAreaGoalsIfNeeded
                                    }
                                />
                            ) : null}
                            <div
                                className="step2EstablishGoal__container"
                                style={{
                                    '--marginCalendar': '0px',
                                }}
                            >
                                <SelectGoalSection
                                    mobile={props.mobile}
                                    FData={dataLoad()[data.CurrentF]}
                                    AllState={data}
                                    saveRecomendedGoals={
                                        saveRecomendedGoals
                                    }
                                    saveAreaGoalsIfNeeded={
                                        saveAreaGoalsIfNeeded
                                    }
                                    portalV2={!!props.portalV2}
                                />
                            </div>
                            {!props.portalV2 &&
                                data.LastReachedF > data.CurrentF &&
                                props.mobile === true && (
                                    <button
                                        className="btnPartialSaveStep2Mobile"
                                        type="button"
                                        disabled={saveAreaLoading}
                                        onClick={() => saveCurrentAreaGoals()}
                                    >
                                        {saveButtonLabel}
                                    </button>
                                )}
                        </div>
                    ) : null}
                </div>
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 2 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-top7"
                                url="https://player.vimeo.com/video/539436782"
                                title="STEP 2: TOP 7 GOALS"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                height="100%"
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section">
                    {data.CurrentStep2 !== 3 ? (
                        ''
                    ) : (
                        <div>
                            <OolaSevenSection
                                handleChangeHeader={props.handleChangeHeader}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                AllState={data}
                                changeData={changeData}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>

                <div className="section">
                    {data.CurrentStep2 !== 4 ? (
                        ''
                    ) : (
                        <div
                            style={
                                props.portalV2
                                    ? undefined
                                    : { overflowY: 'scroll' }
                            }
                        >
                            <OolaOneSection
                                handleChangeHeader={props.handleChangeHeader}
                                AllState={data}
                                changeData={changeData}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 5 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-oolaone"
                                url="https://player.vimeo.com/video/539438606"
                                title="STEP 2: MY OOLA ONE"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                height="100%"
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section">
                    {data.CurrentStep2 !== 6 ? (
                        ''
                    ) : (
                        <div
                            style={
                                props.portalV2
                                    ? undefined
                                    : { minHeight: '130vh' }
                            }
                        >
                            <OolaOneSectionSelect
                                handleChangeHeader={props.handleChangeHeader}
                                AllState={data}
                                changeData={changeData}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>
            <div
                className="section"
                style={{
                    width: '100%',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                }}
            >
                {data.CurrentStep2 === 7 ? (
                <SelectFinishSection
                    isFinishAction={1}
                    AllState={data}
                    handleChangeHeader={props.handleChangeHeader}
                    mobile={props.mobile}
                    changeData={changeData}
                    forceUpdate={forceUpdate}
                    updateIndexStep2={updateIndexStep2}
                    handleChangeindexStep={props.handleChangeindexStep}
                    hideNav={false}
                    portalV2={props.portalV2}
                />
                ) : (
                    ''
                )}
            </div>
            </SwipeableViews>
        </>
    );
    return obj;
};

export default SelectGoalsStep2;
